<template>
  <div class="lvInfoBox">
<!--    直播前-->
    <lvBefore v-if="status==1" :baseInfo="baseInfo" :isOrder="isOrder"></lvBefore>
<!--    直播中-->
<!--    <lvLiving v-if="status==2" style="width: 100%" :baseInfo="baseInfo"></lvLiving>-->
<!--    直播后-->
    <lvLiving v-if="status==2||status==3" style="width: 100%" :baseInfo="baseInfo"></lvLiving>
  </div>
</template>

<script>
import lvBefore from "./lvBefore";
import lvLiving from "./lvLiving";

export default {
  name: "lvInfo",
  props: {
    baseInfo: {
      type: Object,
      required: true
    },
    status: {type: Number, required: true},
    isOrder: {type: Number, required: true}
  },
  components:{
    lvBefore,
    lvLiving
  },
  data(){
    return {
      // myitemC: 200,
    }
  }
}
</script>

<style scoped>
.lvInfoBox{
  position: relative;
  margin: auto;
  width: 990px;
}

</style>